var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.organize_name))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticClass: "tabs",
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "项目工资明细表",
      "name": "XmGzmx"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.gzmxList,
      "show-summary": "",
      "height": "650",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "岗位",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_wages",
      "align": "center",
      "label": "工资总额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "base_pay",
      "align": "center",
      "label": "基本工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_salary",
      "align": "center",
      "label": "岗位工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "daily_wage",
      "align": "center",
      "label": "日工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "days_attendance",
      "align": "center",
      "label": "应出勤天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "事假/缺勤"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "absence_days",
      "align": "center",
      "label": "天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deduction_absence",
      "align": "center",
      "label": "扣款",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_attendance_days",
      "align": "center",
      "label": "实出勤天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages",
      "align": "center",
      "label": "工资额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "增补项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "full_work_attendance",
      "align": "center",
      "label": "满勤",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "meal_supplement",
      "align": "center",
      "label": "餐补",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime",
      "align": "center",
      "label": "加班时间",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime_amount",
      "align": "center",
      "label": "加班金额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute",
      "align": "center",
      "label": "替班",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_charges",
      "align": "center",
      "label": "话费",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute_salary",
      "align": "center",
      "label": "代岗工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "make_up_for_the_early_stage",
      "align": "center",
      "label": "弥补前期",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reward",
      "align": "center",
      "label": "奖励",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "return_of_work_clothes_deposit",
      "align": "center",
      "label": "归还工服押金",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_plus",
      "align": "center",
      "label": "其他+",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "扣款项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "late_deduction",
      "align": "center",
      "label": "迟到扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "penalty_deduction",
      "align": "center",
      "label": "处罚扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pay_the_work_clothes_deposit",
      "align": "center",
      "label": "发放工服押金",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_reduce",
      "align": "center",
      "label": "其他-",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages_payable",
      "align": "center",
      "label": "应发工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "代扣代缴"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "social_security_deduction",
      "align": "center",
      "label": "社保扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance",
      "align": "center",
      "label": "意外保险",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund",
      "align": "center",
      "label": "公积金",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "before_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税前)",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "individual_income_tax",
      "align": "center",
      "label": "个人所得税",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "after_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税后)",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiving_method_name",
      "align": "center",
      "label": "领取方式",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bank_card_number",
      "align": "center",
      "label": "银行卡号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardholder_name",
      "align": "center",
      "label": "持卡人",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entry_name",
      "align": "center",
      "label": "项目名称",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id_card",
      "align": "center",
      "label": "身份证号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_number",
      "align": "center",
      "label": "电话号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "align": "center",
      "label": "性别",
      "width": "60"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支援工资明细表",
      "name": "ZyGzmx"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.zygzmxList,
      "show-summary": "",
      "tooltip-effect": "dark",
      "height": "650"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "岗位",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_wages",
      "align": "center",
      "label": "工资总额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "base_pay",
      "align": "center",
      "label": "基本工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_salary",
      "align": "center",
      "label": "岗位工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "daily_wage",
      "align": "center",
      "label": "日工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "days_attendance",
      "align": "center",
      "label": "应出勤天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "事假/缺勤"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "absence_days",
      "align": "center",
      "label": "天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deduction_absence",
      "align": "center",
      "label": "扣款",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_attendance_days",
      "align": "center",
      "label": "实出勤天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages",
      "align": "center",
      "label": "工资额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "增补项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "full_work_attendance",
      "align": "center",
      "label": "满勤",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "meal_supplement",
      "align": "center",
      "label": "餐补",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime",
      "align": "center",
      "label": "加班时间",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime_amount",
      "align": "center",
      "label": "加班金额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute",
      "align": "center",
      "label": "替班",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_charges",
      "align": "center",
      "label": "话费",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute_salary",
      "align": "center",
      "label": "代岗工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "make_up_for_the_early_stage",
      "align": "center",
      "label": "弥补前期",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reward",
      "align": "center",
      "label": "奖励",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "return_of_work_clothes_deposit",
      "align": "center",
      "label": "归还工服押金",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_plus",
      "align": "center",
      "label": "其他+",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "扣款项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "late_deduction",
      "align": "center",
      "label": "迟到扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "penalty_deduction",
      "align": "center",
      "label": "处罚扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pay_the_work_clothes_deposit",
      "align": "center",
      "label": "发放工服押金",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_reduce",
      "align": "center",
      "label": "其他-",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages_payable",
      "align": "center",
      "label": "应发工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "代扣代缴"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "social_security_deduction",
      "align": "center",
      "label": "社保扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance",
      "align": "center",
      "label": "意外保险",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund",
      "align": "center",
      "label": "公积金",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "before_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税前)",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "individual_income_tax",
      "align": "center",
      "label": "个人所得税",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "after_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税后)",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiving_method_name",
      "align": "center",
      "label": "领取方式",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bank_card_number",
      "align": "center",
      "label": "银行卡号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardholder_name",
      "align": "center",
      "label": "持卡人",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entry_name",
      "align": "center",
      "label": "项目名称",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id_card",
      "align": "center",
      "label": "身份证号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_number",
      "align": "center",
      "label": "电话号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "align": "center",
      "label": "性别",
      "width": "60"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_reviewer_state == 0),
      expression: "is_reviewer_state == 0"
    }]
  }, [_c('el-col', {
    staticStyle: {
      "margin": "20px 40%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].save(_vm.id, 1)
      }
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].reject(_vm.id)
      }
    }
  }, [_vm._v("驳回")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap",
      "margin": "0 20px"
    }
  }, _vm._l((_vm.inforchilds), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 6)",
        "min-width": "calc((100% - 20px) / 6)",
        "max-width": "calc((100% - 20px) / 6)"
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "20px 0 0 0",
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(item.role_name) + " : " + _vm._s(item.staff_name))])])
  }), 0)], 1)], 1), _vm._v(" "), _c('examine', {
    ref: "examine",
    attrs: {
      "spare": _vm.spare,
      "id": _vm.id
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe4e149","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/QAsp/Gzhz_gzmx.vue
// module id = null
// module chunks = 